import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {
  Button,
  Menu,
  Icon,
  Image,
  TransitionablePortal,
  withApplicationTheme,
  ProductLine,
} from '@adc/ui-core'
import classNames from 'classnames/bind'
import {
  mobileLoggedInDropdown,
  getNewAllDropdown,
  smartSaleMobileLoggedInDropdown,
} from '../constants/menus'
import MenuItem from '../menuItem'
import BellNotification from '../menuItem/bellNotification'
import { generalRoutes, USER_LOGIN, USER_SIGN_UP } from '../constants/routes'
import auctioncomIconLogo from '../../../img/auction-logo-mobile.svg'
import smartsaleIconLogo from '../../../img/smartsale-logo.svg'
import auctioncomLogo from '../../../img/logo-light.svg'
import smartsaleLogo from '../../../img/smartsale-powered-logo.svg'
import Search from '../../search'
import cls from '../styles.scss'
const cx = classNames.bind(cls)

class MobileHeader extends PureComponent {
  static propTypes = {
    customLogo: PropTypes.string,
    featureFlags: PropTypes.object,
    isSticky: PropTypes.bool,
    liveChat: PropTypes.node,
    onLoginClick: PropTypes.func,
    onLogoutClick: PropTypes.func,
    onSignupClick: PropTypes.func,
    user: PropTypes.object,
    showSearch: PropTypes.bool,
    hasNotification: PropTypes.bool,
    onSearchSubmit: PropTypes.func,
    onClickBell: PropTypes.func,
    bellNotificationsCount: PropTypes.string,
    filters: PropTypes.object,
    theme: PropTypes.object,
    forceSmartSaleLogo: PropTypes.bool,
    showLinks: PropTypes.bool,
  }

  static defaultProps = {
    featureFlags: {},
    isSticky: false,
    liveChat: null,
    onLoginClick: _.noop,
    onSignupClick: _.noop,
    user: null,
    hasNotification: false,
    showSearch: true,
    onClickBell: _.noop,
    theme: {},
    showLinks: true,
  }

  state = {
    isMenuOpen: false,
  }

  menuClose = () => this.setState({ isMenuOpen: false })

  menuToggle = () => this.setState({ isMenuOpen: !this.state.isMenuOpen })

  onSignupClick = e => {
    this.menuClose()
    this.props.onSignupClick(e)
  }

  onLoginClick = e => {
    this.menuClose()
    this.props.onLoginClick(e)
  }

  render() {
    const {
      customLogo,
      featureFlags,
      hasNotification,
      showSearch,
      user,
      onClickBell,
      bellNotificationsCount,
      filters,
      onSearchSubmit,
      theme,
      showLinks,
      forceSmartSaleLogo,
    } = this.props
    const { isMenuOpen } = this.state
    const authRoutes = [
      {
        ...generalRoutes.logIn,
        elmId: `mh_${USER_LOGIN}`,
        onClick: this.onLoginClick,
      },
      {
        ...generalRoutes.signUp,
        elmId: `mh_${USER_SIGN_UP}`,
        onClick: this.onSignupClick,
      },
    ]

    let defaultMobileLogo
    if (theme.productLine === ProductLine.SmartSale || forceSmartSaleLogo) {
      defaultMobileLogo = showSearch ? smartsaleIconLogo : smartsaleLogo
    } else {
      defaultMobileLogo = showSearch ? auctioncomIconLogo : auctioncomLogo
    }

    const addOffers = featureFlags['fe.resi.direct_offers']
    const loggedInMenuEntries =
      theme.productLine === ProductLine.SmartSale
        ? smartSaleMobileLoggedInDropdown()
        : mobileLoggedInDropdown(addOffers, featureFlags)
    const newAllDropdown = getNewAllDropdown(featureFlags, theme)

    const defaultLogo = (
      <div className={cx('u-pr-1')}>
        <Image
          className={cx('icon', 'mobile-icon')}
          src={customLogo || defaultMobileLogo}
          floated='left'
          data-elm-id='mh_logo'
          alt='logo'
        />
        <Icon
          className={cx(
            isMenuOpen ? 'angle-down' : 'angle-up',
            showSearch ? '' : 'wide-logo'
          )}
          name='angle down'
        />
      </div>
    )

    return (
      <div data-elm-id='header' className={cx('mobile-menu')}>
        <Menu borderless>
          <TransitionablePortal
            transition={{ animation: 'slide down', duration: 25 }}
            trigger={
              <Menu.Item
                onClick={this.menuToggle}
                className={cx(
                  showSearch
                    ? 'mobile-menu-portal-toggle'
                    : 'mobile-wide-logo-toggle'
                )}
                data-elm-id='mh_portal_toggle'
                content={defaultLogo}
              />
            }
            open={isMenuOpen}
          >
            <Menu
              vertical
              size='large'
              className={cx(
                'mobile-dropdown',
                isMenuOpen ? 'open' : 'closed',
                hasNotification && 'with-notification'
              )}
            >
              {!user.logged_in &&
                authRoutes.map(item => (
                  <MenuItem
                    key={item.title}
                    {...item}
                    elmId={`mh_${item.elmId}`}
                  />
                ))}
              <MenuItem
                className={cx('home', 'mobile-division')}
                url='/'
                title='Home'
                elmId='mh_home'
              />
              {user.logged_in &&
                theme.productLine === ProductLine.AuctionCom && (
                  <BellNotification
                    bellNotificationsCount={bellNotificationsCount}
                    onClick={onClickBell}
                  />
                )}
              {user.logged_in &&
                loggedInMenuEntries.map((item, index) => (
                  <MenuItem key={index} {...item} />
                ))}
              {showLinks &&
                newAllDropdown.map((item, index) => (
                  <MenuItem key={index} {...item} />
                ))}
              {this.props.liveChat}
              {user.logged_in && (
                <MenuItem
                  {...generalRoutes.logOut}
                  onClick={this.props.onLogoutClick}
                  className={generalRoutes.logOut.className}
                  elmId='mh_user_logout'
                />
              )}
            </Menu>
          </TransitionablePortal>
          {!showSearch && !user.logged_in && (
            <Menu.Menu
              position='right'
              // want to keep the space this occupies even if hidden, so that ADC logo gets shrunken the same way
              // as it is when menu is closed (less janky)
              style={{ visibility: isMenuOpen ? 'hidden' : 'visible' }}
            >
              <MenuItem
                {...generalRoutes.logIn}
                onClick={this.props.onLoginClick}
                elmId='mh_user_login'
              >
                <Button role='secondary'>Log In</Button>
              </MenuItem>
            </Menu.Menu>
          )}
          {showSearch && (
            <div className='u-mt-1 u-stretch'>
              <Search
                elmId='mobile'
                filters={filters}
                onSearchSubmit={onSearchSubmit}
                user={user}
                categorizeResults
              />
            </div>
          )}
        </Menu>
      </div>
    )
  }
}

export default withApplicationTheme(MobileHeader)
const MobileHeaderNoTheme = MobileHeader
export { MobileHeaderNoTheme }
